export default function ApplicationLogoutIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 0H0V24H24V0Z" fill="white" fill-opacity="0.01" />
      <path
        d="M11.9958 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H12"
        stroke="#D80027"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 16.5L21 12L16.5 7.5"
        stroke="#D80027"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 11.9958H21"
        stroke="#D80027"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
